 
export default function SidebarCollapsedSvgIcon() {
    return (
        <div style={{marginRight:"18px"}}>
        <svg
            xmlns="http://www.w3.org/2000/svg"
            width="30"
            height="30"
            viewBox="0 0 131.29 127.641"
        >
            <rect width="131.29" height="127.641" fill="transparent" />
            <g id="softaverapay555" transform="translate(197.463 100.919)">
                <g id="Groupe_9" transform="translate(-197.463 -100.919)">
                    <path
                        id="Tracé_20"
                        d="M-166.7-57.859h.419l12.443.552h25.164l-11.884-12.3h-19.575a25.336,25.336,0,0,1-24.454-19.007l-12.871-12.3v8.109a5.729,5.729,0,0,0,.141,1.537c0,.418.139.838.139,1.4v.418c0,.28.141.553.141.838a6.135,6.135,0,0,0,.279,1.4v.139c.14.553.14.978.28,1.537a9.425,9.425,0,0,1,.838,2.093,6.837,6.837,0,0,0,.553,1.537v.14a16.224,16.224,0,0,1,.551,1.537,16.732,16.732,0,0,0,.7,1.537,28.305,28.305,0,0,0,1.538,2.942c.279.419.552.978.838,1.4.14.28.419.553.553.838.279.28.418.553.7.838s.419.552.7.838a3.779,3.779,0,0,0,.978,1.119,32.472,32.472,0,0,0,6.011,5.593c.419.279.838.7,1.258.978l1.257.838h0l1.257.838.14.14c.419.14.7.42,1.118.552a12.8,12.8,0,0,0,1.4.7c.552.279.978.418,1.537.7.419.14.7.279,1.118.418.7.28,1.537.552,2.238.838a9.351,9.351,0,0,1,.979.28,13.183,13.183,0,0,0,2.237.552A3.267,3.267,0,0,0-166.7-57.859Z"
                        transform="translate(197.463 100.919)"
                        fill="#FFFFFF"
                    />
                    <path
                        id="Tracé_21"
                        d="M-125.867-21.745h19.013l-11.884-12.3H-138.31a12.775,12.775,0,0,1-10.2-5.034c-.141-.278-.419-.551-.553-.838a3,3,0,0,1-.418-.7,7.408,7.408,0,0,1-.7-1.537,11.591,11.591,0,0,1-.838-4.473v-6.441s-12.582-.551-12.443-.551l.141,6.986v1.257h0a24.961,24.961,0,0,0,5.312,14.119,21.384,21.384,0,0,0,2.377,2.658,3.711,3.711,0,0,0,.838.7c.279.28.7.552.977.838.28.14.552.419.838.551a5.948,5.948,0,0,0,.978.7c.279.138.7.418.978.552s.7.418.978.552.7.418.977.552h0c.419.14.7.28,1.119.42s.7.279,1.118.418a18.166,18.166,0,0,0,4.753,1.119c.418,0,.7.141,1.118.141a15.259,15.259,0,0,0,2.517.138h12.582Z"
                        transform="translate(194.518 109.038)"
                        fill="#FFFFFF"
                    />
                    <path
                        id="Tracé_22"
                        d="M-73.113.43h-37.328a12.769,12.769,0,0,1-12.722-12.718h0v-6.436h-12.3v6.436h0v.976h0a25.073,25.073,0,0,0,8.528,17.755,3.711,3.711,0,0,0,.838.7,23.218,23.218,0,0,0,3.914,2.517c.419.14.7.42,1.118.552a8.417,8.417,0,0,1,1.118.553c.279.138.7.279.979.418.418.14.7.28,1.118.418a4.291,4.291,0,0,0,1.118.28,21.488,21.488,0,0,0,6.011.7H-61.09Z"
                        transform="translate(192.092 114.909)"
                        fill="#FFFFFF"
                    />
                    <path
                        id="Tracé_23"
                        d="M-66.173,26.722V-50.164c-.035-28.019-18.984-50.718-42.367-50.755h-88.917l12.871,14.739h76.045c16.59.031,30.033,16.136,30.058,36.016V11.982Z"
                        transform="translate(197.463 100.919)"
                        fill="#FFFFFF"
                    />
                </g>
            </g>
        </svg>
        </div>
    );
}
